import {} from "@api/client";

const TOKEN_KEY = "token";

namespace AuthService {
	export const getToken = () => {
		let token = sessionStorage.getItem(TOKEN_KEY);

		return token ? JSON.parse(token) : "";
	};

	const checkAuthentication = () => {
		let token = getToken();

		if (token) return true;

		return false;
	};

	export const isAuthenticated = () => checkAuthentication();

	export const setAuthentication = (token: string | undefined) => {
		if (token) sessionStorage.setItem(TOKEN_KEY, JSON.stringify(token));
	};

	export const logout = () => {
		sessionStorage.removeItem(TOKEN_KEY);
		window.location.reload();
	};
}
export default AuthService;
